<template>
	<div class="o-container o-container--thin onboarding-page">
		<subscriptions-form :contactId="this.data.contactId" />
	</div>
</template>

<script>
    import SubscriptionsForm from '../forms/SubscriptionsForm.vue';

    export default {
      components: {
        SubscriptionsForm
      },
      props: ['contactId', 'message'],
      data() {
        return {
          data: {
            contactId: ''
          }
        };
      },
      created() {
        this.validateProps();
      },
      methods: {
        validateProps() {
          if (this.contactId) {
            this.data.contactId = this.contactId;
          }
        }
      }
    }
</script>
